// packages
import Odometer from 'odometer';
import { Component, h } from 'preact';


Odometer.options.auto = false;

interface Props {
  value: number;
  format: (n: number) => string;
  odometerFormat?: string;
}

// Odometer drops trailing zeros after the decimal point so this fixes it
function keepTrailingZeros(odometer: any) {
  const { precision } = odometer.format;
  if (!precision) return;

  odometer.formatDigits = function (value: number) {
    this.digits = [];
    let wholePart = false;
    value
      .toFixed(precision)
      .split('')
      .reverse()
      .forEach((digit: string) => {
        if (digit === '.') wholePart = true;
        this.addDigit(digit, wholePart);
      });
  };

  const getFractionalDigitCount = odometer.getFractionalDigitCount;
  odometer.getFractionalDigitCount = function (...values: number[]) {
    return Math.max(precision, getFractionalDigitCount.apply(this, values));
  };

  // Redraw the initial value with the tweaked formatting
  odometer.render();
}

// Rolling number powered by the odometer library
class AnimatedNumber extends Component<Props> {
  el: HTMLElement;
  srEl: HTMLElement;
  odometer: any;

  componentDidMount() {
    const { value, odometerFormat } = this.props;

    // Preact 8 can recycle the DOM of an unmounted AnimatedNumber (e.g. when
    // the embed switcher swaps races). Odometer hands back the old instance
    // for an element that already has one, which leaves the number blank, so
    // always give it a brand-new element.
    const odometerEl = document.createElement('span');
    this.el.appendChild(odometerEl);

    this.odometer = new Odometer({
      el: odometerEl,
      value,
      format: odometerFormat || '(,ddd)',
      theme: 'plain',
      duration: 1200,
    });

    keepTrailingZeros(this.odometer);
  }

  shouldComponentUpdate(nextProps: Props) {
    if (nextProps.value !== this.props.value) {
      this.odometer.update(nextProps.value);
      this.srEl.textContent = nextProps.format(nextProps.value);
    }

    return false;
  }

  render({ value, format }: Props) {
    return (
      <span class="animated-number">
        <span class="is-sr-only" ref={(el) => (this.srEl = el)}>
          {format(value)}
        </span>
        <span aria-hidden="true" ref={(el) => (this.el = el)} />
      </span>
    );
  }
}

export default AnimatedNumber;
